import React, { ReactElement } from 'react';
import './statements.less';
import Layout from './Layout';
import AnnualStatements from './AnnualStatements';
import MonthlyStatements from './MonthlyStatements';
import { Alert } from 'react-bootstrap';

export default function Statements(): ReactElement {
    return (
        <Layout section='statements'>
            <h1>Statements</h1>
            <Alert>
                <Alert.Heading>Annual Income Statement available soon</Alert.Heading>
                <p>Your Annual Income Statements for the year ended 30 June 2026 are currently being processed. Once they have been completed, you will receive an email confirming they are ready to access and download.</p>
                <p>Thank you for your patience and your continued support during FY2026.</p>
            </Alert>
            <div className='statements'>
                <AnnualStatements />
                <MonthlyStatements />
            </div>
        </Layout>
    );
}
